import { render, staticRenderFns } from "./DonationPurchase.vue?vue&type=template&id=1e1271d2&scoped=true&"
import script from "./DonationPurchase.vue?vue&type=script&lang=js&"
export * from "./DonationPurchase.vue?vue&type=script&lang=js&"
import style0 from "./DonationPurchase.vue?vue&type=style&index=0&id=1e1271d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e1271d2",
  null
  
)

export default component.exports